// Web version
export default function SmartlookMobileOnly() {
  return null;
}
